import { priceLabel, type Plan } from "@/pages/account/platform";
import { useTrials } from "@/site/trials";

/**
 * Days of a new account's free trial (0 = no trial), from the free-trial
 * switches in Admin → Plans & trials → Sign-up & trial (`/public/trials`): the
 * member trial, or the Research Analyst trial with `role: "ra"`.
 */
export function useTrialDays(role: "investor" | "ra" = "investor"): number {
  const t = useTrials();
  return (role === "ra" ? t.ra : t.member) ?? 0;
}

/** "7 days free, then ₹4,999/month incl. GST" (or just the price without a trial). */
export function trialPriceLabel(p: Plan, trialDays: number): string {
  return trialDays > 0 ? `${trialDays} days free, then ${priceLabel(p)}` : priceLabel(p);
}
